module.exports = __webpack_public_path__ + "img/razzo-head-page.a9aabffa.png";